import { node } from "~/util/dom";
import { setFormat } from ".";
import GPSSWitchVisualizer from "./visualizer";

/**
 * zobrazeni souradnic ve slideru
 */
export default class GPSSWitchVisualizerSlider {
	_owner: GPSSWitchVisualizer;

	_dom: {
		items: Array<any>;
		container: HTMLDivElement;
		rails: HTMLFormElement;
		arrow: HTMLAnchorElement;
	};

	_gps: any; // GPSSwitch

	_sliderContent: DocumentFragment;

	_timeoutAnimation: number;

	constructor(owner: GPSSWitchVisualizer) {
		this._owner = owner;

		this._dom = {
			items: [],
			container: node("div", { className: "gps-slider" }),
			rails: node("form", { className: "rails" }),
			arrow: node("a", { className: "arrow", href: "#" }),
		};

		// @ts-ignore
		this._gps = Mapy.getComponent("gps");

		this._timeoutAnimation = 0;

		this._build();
	}

	destroy() {
		for (let index = 0; index < this._dom.items.length; index++) {
			this._dom.items[index].removeEventListener("focus", this);
		}

		this._dom.arrow.removeEventListener("click", this, false);

		if (this._timeoutAnimation) {
			clearTimeout(this._timeoutAnimation);
			this._timeoutAnimation = 0;
		}
	}

	getContainer() {
		return this._dom.container;
	}

	/**
	 * zachycovani udalosti
	 */
	handleEvent(event: Event) {
		if (event.type === "click" && event.target === this._dom.arrow) {
			this._slide(event);
		} else if (event.type === "focus") {
			const target = event.target as HTMLInputElement;

			target.select();
		}
	}

	/**
	 * vytvoreni elementu
	 */
	_build() {
		this._dom.rails.innerHTML = "";
		this._insertItems(this._gps.getFormatIndex(), this._gps.getFormatsCount());

		this._dom.arrow.addEventListener("click", this, false);

		this._sliderContent = document.createDocumentFragment();

		this._sliderContent.appendChild(this._dom.rails);
		this._sliderContent.appendChild(this._dom.arrow);
		this._dom.container.appendChild(this._sliderContent);
	}

	/**
	 * vlozeni itemu
	 * @param {number} start - index prvniho (defaultne nastaveneho) formatu
	 * @param {number} end - index posledniho formatu
	 */
	_insertItems(start: number, end: number) {
		this._dom.rails.innerHTML = "";

		for (let index = start; index < end; index++) {
			const item = node("input", { type: "text" });

			item.setAttribute("readonly", "readonly");
			item.addEventListener("focus", this);
			this._dom.items[index] = item;
			this._dom.rails.appendChild(item);
		}

		if (start > 0) {
			this._insertItems(0, start);
		}
	}

	/**
	 * aktualizace itemu
	 */
	actualizeItems() {
		const coordsFormat = this._owner.getFormatCoords();

		for (let index = 0; index < coordsFormat.length; index++) {
			this._dom.items[index].value = coordsFormat[index];
		}
	}

	reorderItems(start: number, end: number) {
		for (let index = start; index < end; index++) {
			this._dom.rails.appendChild(this._dom.items[index]);
		}
		if (start > 0) {
			this.reorderItems(0, start);
		}
	}

	/**
	 * posunuti ve slidu
	 */
	_slide(event: Event) {
		if (event) {
			event.preventDefault();
		}

		let formatIndex = this._gps.getFormatIndex() as number;

		if (!this._dom.arrow.classList.contains("hide")) {
			this._dom.rails.classList.add("slide");
			this._dom.arrow.classList.add("hide");
			if (formatIndex < this._gps.getFormatsCount()-1) {
				formatIndex++;
			} else {
				formatIndex = 0;
			}

			this._timeoutAnimation = window.setTimeout(() => {
				this._slideEnd();
				setFormat(formatIndex);
			}, 300);
		}
	}

	/**
	 * volane po ukonceni slidovani - prerovnani elementu
	 */
	_slideEnd() {
		this._dom.rails.classList.remove("slide");
		this._dom.arrow.classList.remove("hide");
		this._dom.rails.appendChild(this._dom.rails.getElementsByTagName("input")[0]);
	}
}
